import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import useVehicleFilterStore, { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

import texts from '../../VehicleListV2.texts.json';
import { CheckboxFilterDropdown } from '../dropdowns/CheckboxFilterDropdown';
import type { CheckboxChipConfig } from '../FilterBarV2.consts';
import { CHECKBOX_OPTIONS_MAP } from '../FilterBarV2.consts';
import { applyCheckboxFilter, clearCheckboxFilter, getActiveLabel, getCheckboxSelected } from '../FilterBarV2.helpers';

import { FilterChip } from './FilterChip';

const LocalT = new MDText(texts);

export const CheckboxFilterChip: FC<{ chipConfig: CheckboxChipConfig }> = ({ chipConfig }) => {
	const filters = useFilters();
	const setValue = useVehicleFilterStore((store) => store.setValue);
	const label = `${LocalT.translate(chipConfig.labelKey)}`;
	const activeLabel = getActiveLabel({ filterId: chipConfig.id, filters });
	const options = CHECKBOX_OPTIONS_MAP[chipConfig.filterId] ?? [];

	return (
		<FilterChip activeLabel={activeLabel} id={chipConfig.id} isActive={!!activeLabel} label={label}>
			{({ onClose, resetKey }) => (
				<CheckboxFilterDropdown
					key={resetKey}
					onApply={(selected) => applyCheckboxFilter({ config: chipConfig, selected, setValue })}
					onClear={() => clearCheckboxFilter({ config: chipConfig, setValue })}
					onClose={onClose}
					options={options}
					selected={getCheckboxSelected({ config: chipConfig, filters, optionsMap: CHECKBOX_OPTIONS_MAP })}
					title={label}
				/>
			)}
		</FilterChip>
	);
};
